module.exports = __webpack_public_path__ + "static/img/2.85d03db0.png";